import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Label = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
}));
